import {SurveyValidator, SurveyValidatorResult} from './SurveyValidator'

export class SurveyValidatorCondition extends SurveyValidator {
  private findPageIndex(forName: string) {
    return this.survey.pages.findIndex((page) => page.name === forName)
  }

  result(): Promise<SurveyValidatorResult[]> {
    const result: SurveyValidatorResult[] = []
    this.survey.pages.forEach((page, pageIndex) => {
      const target = page.elements.filter((el) => el.condition !== undefined)
      target.forEach((element) => {
        // Check if conditioning the same element
        if (element.condition?.target?.element === element.name) {
          result.push({
            pageName: page.name,
            elementName: element.name,
            level: 'ERROR',
            description: 'Cannot condition element with itself'
          })
        }
        // Check for empty targets
        if (
          !element.condition?.target?.page ||
          !element.condition?.target?.element
        ) {
          result.push({
            pageName: page.name,
            elementName: element.name,
            level: 'ERROR',
            description: 'Invalid condition target'
          })
        }
        // Check for chronological issues
        if (
          pageIndex < this.findPageIndex(element.condition?.target?.page ?? '')
        ) {
          result.push({
            pageName: page.name,
            elementName: element.name,
            level: 'WARNING',
            description: 'Chronological dependencies mismatch'
          })
        }
      })
    })
    return Promise.resolve(result)
  }
}
